module.exports = __webpack_public_path__ + "md.svg?06e48865e1de32e108d473fb7dd7f488";